import ThemedComponent from '../../hoc/ThemedComponent';

import { default as FilterViewDefault } from './Filter/View';
import { default as FilterView3 } from '../../themes/3/components/Filter/Filter';

const ThemedFilter = {
  default: FilterViewDefault,
  // 3: FilterView3,
};

export const FilterView = ThemedComponent(ThemedFilter); 

